export const DEFAULT_STATE = {
    activeDialogName: "",
    heading: "",
    item: null,
};
